// extracted by mini-css-extract-plugin
module.exports = {"data-table":"Table-module__data-table___1JMb0"};